// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "social.halo",
    name: "Halo Wallet",
    homepage: "https://halo.social/",
    image_id: "80583973-8b44-4bef-0af9-099cfdbed600",
    app: {
        browser: null,
        ios: "https://apps.apple.com/hk/app/id1633572905",
        android: "https://play.google.com/store/apps/details?id=com.kucoin.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/halo-wallet/nbdpmlhambbdkhkmbfpljckjcmgibalo",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "halowallet://",
        universal: "https://link.kuwallet.com/universallink",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map